/**
 * Collect the facility profile and its options into a format 
 * for sending to the backend API.
 *
 * @param  {Object}  profile
 * @param  {Array}   options
 * @return {Object}  Ex: {7: {309: {312: {342: {351: "351", 353: "353"}}}}
 */
export function prepareFacilityOptions(profile, options) {

  // Collect and prepare the profile id tree.
  let ids = profile.parents.slice(0).reverse()
  ids.push(profile.id)

  // Collect and prepare the options.
  let initialValue

  if (options) {
    initialValue = {}
    for (let i = 0; i < options.length; i++) {
      initialValue[options[i].id.toString()] = options[i].id.toString()
    }

  } else {
    initialValue = profile.id.toString()
  }

  return ids.reduceRight((carry, id) => ({[id]: carry}), initialValue)
}
